import { FC, useContext } from 'react';
import {
  BoxProps,
  Flex,
  Image,
  useBreakpointValue,
  VStack,
} from '@chakra-ui/react';

import Text from 'components/_core/Text';
import TreezorUpload, {
  FILE_SIZE,
  FILE_TYPE,
} from 'features/Onboarding/legacy/components/TreezorUpload';

import Clipboard from '../../assets/Clipboard@2x.png';
import OBUploadContext from '../../lib/context';
import locales from './locales';

interface UploadZoneProps extends BoxProps {
  title?: string;
  description?: string;
}

/**
 * Will later be exported in a core Upload component.
 */
const UploadZone: FC<UploadZoneProps> = ({
  description = locales.uploadDescription,
  title,
  ...props
}) => {
  const { onSuccessfulUpload, uploadFile } = useContext(OBUploadContext);

  const isMobile = useBreakpointValue({ base: true, md: false });

  return (
    <TreezorUpload
      errorMessage={locales.uploadFailureMessage}
      fileTypes={FILE_TYPE.ALLOWED_DOCUMENTS}
      maxByteSizeParam={FILE_SIZE.SUPPORTING_DOCUMENTS}
      onSuccessfulUpload={onSuccessfulUpload}
      uploadFile={uploadFile}
    >
      <VStack spacing="space-32" {...props}>
        <Image boxSize="120px" src={Clipboard} />

        <Flex align="center" direction="column">
          <Text
            fontWeight="weight-500"
            marginBottom="space-8"
            size="lg"
            variant="primary"
          >
            {isMobile
              ? locales.uploadTitle.touch
              : title ?? locales.uploadTitle.regular}
          </Text>

          {isMobile === false && description ? (
            <Text variant="light">{description}</Text>
          ) : null}
        </Flex>
      </VStack>
    </TreezorUpload>
  );
};
export default UploadZone;
